var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextStrike = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M5 10.5A2.5 2.5 0 0 0 7.5 13h1a2.5 2.5 0 0 0 2.5-2.5 2.61 2.61 0 0 0-1.153-2.167M11 5.5A2.5 2.5 0 0 0 8.5 3h-1A2.5 2.5 0 0 0 5 5.5c0 .903.46 1.699 1.153 2.167M3 8h10"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextStrike);
export default ForwardRef;